import { render } from "./AccountCard.vue?vue&type=template&id=059bc83d&scoped=true"
import script from "./AccountCard.vue?vue&type=script&lang=js"
export * from "./AccountCard.vue?vue&type=script&lang=js"

import "./AccountCard.vue?vue&type=style&index=0&id=059bc83d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059bc83d"]])

export default __exports__